import {createContext, useContext} from 'react';
import {SeniorSiderbarType} from './types';

// Create Context
export const SeniorsSidebarContext = createContext<SeniorSiderbarType>({} as SeniorSiderbarType);

// Encapsulated context hook
export const useSeniorSidebar = () => useContext(SeniorsSidebarContext);
